import { render, staticRenderFns } from "./vantabbar.vue?vue&type=template&id=3a3cc05e"
import script from "./vantabbar.vue?vue&type=script&lang=js"
export * from "./vantabbar.vue?vue&type=script&lang=js"
import style0 from "./vantabbar.vue?vue&type=style&index=0&id=3a3cc05e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports